module.exports = __webpack_public_path__ + "img/arrival_11.75ffaf6e.jpg";